import LoadingButton from "@mui/lab/LoadingButton";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  API_URL,
  calculateDates,
  ConvertToMiladiDateDB,
  handleSendMessage,
} from "../../utilities";
import { useAuth } from "../../context/auth";
import { useNotifications } from "@toolpad/core/useNotifications";
import React, { useEffect, useState } from "react";
import { StatusGlobal } from "src/interface/enum/StatusGlobal";
import { FollowUpType } from "src/interface/enum/FollowUpType";
import TabSchedules from "./components/tab-schedules";
import { IFollowupSchedule } from "src/interface/IFollowupSchedule";
import { IAutoCompleteLabelValue } from "src/interface/enum/GeneralType";
import { TypeUser } from "src/interface/enum/TypeUser";
import { IAppUser } from "src/interface/IUser";
import { getRoutes } from "src/utilities/routes";

const validationSchema = Yup.object({
  scheduleStatus: Yup.string().required("این فیلد الزامی است"),
  followUpType: Yup.string().required("این فیلد الزامی است"),
  endedOn: Yup.string().required("این فیلد الزامی است"),
  startedOn: Yup.string().required("این فیلد الزامی است"),
  // creatorRef: Yup.string().required("این فیلد الزامی است"),
  title: Yup.string().required("این فیلد الزامی است"),
});

const initialValues = {
  customerRef: undefined,
  creatorRef: undefined,
  title: "",
  startedOn: "",
  endedOn: "",
  childDesc: "",
  followUpType: undefined,
  scheduleStatus: StatusGlobal.NotStarted,
  period: undefined,
  parentRef: undefined,
  agreementRef: undefined,
  isActive: true,
  isGeneral: "true",
  isSMS: false,
  desc: "",
};

const NewFollowupSchedule = ({
  open,
  handleClose,
  refetch,
  isEdit = false,
  followupId,
  setFollowupId,
}: {
  open: boolean;
  handleClose: () => void;
  refetch: () => void;
  isEdit: boolean;
  followupId?: number;
  setFollowupId: (serviceId?: number) => void;
}) => {
  const { user } = useAuth();
  const [data, setData] = useState<IFollowupSchedule>();

  const Routes = getRoutes();
  const { mutateAsync: fetchData } = useMutation({
    mutationFn: async (id: string) => {
      const response = await fetch(API_URL + "followup-schedule/" + id, {
        method: "Get",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      if (responseData.status === true) setData(responseData.data);
      else
        handleSendMessage(
          notifications,
          "خطا در دریافت اطلاعات" + responseData.data,
          "error"
        );
    },
    onError: (error) => {
      handleSendMessage(
        notifications,
        "خطا در اتصال به سرور. لطفاً اتصال اینترنت خود را بررسی کنید.",
        "error"
      );
    },
  });

  const { mutateAsync: fetchChildData } = useMutation({
    mutationFn: async (parentRef: string) => {
      const response = await fetch(
        API_URL + "followup-schedule/by-parent/" + parentRef,
        {
          method: "Get",
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json-patch+json",
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );
      return await response.json();
    },
    onSuccess: (responseData) => {
      if (responseData.status === true) setFollwupsSchedule(responseData.data);
      else
        handleSendMessage(
          notifications,
          "خطا در دریافت اطلاعات" + responseData.data,
          "error"
        );
      //JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  useEffect(() => {
    if (followupId && isEdit) {
      fetchData(followupId.toString());
    }
  }, [followupId]);

  const { mutateAsync: insertAsync, isPending } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(API_URL + "followup-schedule", {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });
  const { mutateAsync: updateAsync, isPending: isEditLoading } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(API_URL + "followup-schedule/" + body.id, {
        method: "PUT",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      handleSendMessage(
        notifications,
        "خطا در دریافت اطلاعات" + error,
        "error"
      );
    },
  });

  const [dates, setDates] = useState<string[]>([]);
  const [followupsSchedule, setFollwupsSchedule] = useState<
    IFollowupSchedule[]
  >([]);

  const notifications = useNotifications();

  const { mutateAsync: deleteAsync, isPending: isDeleteLoading } = useMutation({
    mutationFn: async (followupScheduleId: string) => {
      const response = await fetch(
        API_URL + "followup-schedule/" + followupScheduleId,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${user?.token}`,
            Accept: "application/json",
          },
        }
      );
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      handleSendMessage(
        notifications,
        "خطا در دریافت اطلاعات" + error,
        "error"
      );
    },
  });

  const formik = useFormik({
    initialValues, // مقادیر اولیه فرم
    validationSchema, // schema اعتبارسنجی
    onSubmit: async (values) => {
      let res: any;
      // تبدیل تاریخ ورودی به شیء تاریخ
      const startedOn = ConvertToMiladiDateDB(values.startedOn);
      const endedOn = ConvertToMiladiDateDB(values.endedOn);
      const period = values.period
        ? values.period === 0
          ? 1
          : values.period
        : 1;
      const followUpType = values.followUpType
        ? parseInt(values.followUpType, 10)
        : FollowUpType.Monthly;
      if (
        isEdit &&
        (formik.values.parentRef !== null ||
          formik.values.parentRef !== undefined)
      ) {
        res = await updateAsync({
          ...values,
          childDesc: values.childDesc,
          creatorRef: values.creatorRef,
          id: followupId,
        });
      } else if (isEdit) {
        res = await updateAsync({
          ...values,
          startedOn: startedOn,
          endedOn: endedOn,
          period: period,
          followUpType: followUpType,
          id: followupId,
        });
      } else {
        res = await insertAsync({
          ...values,
          startedOn: startedOn,
          endedOn: endedOn,
          period: period,
          followUpType: followUpType,
        });
      }

      if (res.status === true) {
        notifications.show("پیگیری جدید با موفقیت ثبت شد!", {
          key: "new-task",
          severity: "success",
          autoHideDuration: 5000,
        });
        if (
          formik.values.parentRef === null ||
          formik.values.parentRef === undefined
        ) {
          followupsSchedule.map(async (item: IFollowupSchedule) => {
            if (isEdit) {
              if (
                !item.dueOn ||
                item.dueOn === undefined ||
                item.dueOn === null
              ) {
                await deleteAsync(item.id?.toString() ?? "");
              } else {
                //TODO اگر دوره پیگیری از نوع قرار داد بود نتونه توضیحات مادر رو عوض کنه
                const res = await updateAsync({
                  ...item,
                  followUpType: item.followUpType ?? FollowUpType.Monthly,
                  parentRef: followupId,
                  desc: item.desc,
                  id: item.id,
                });
              }
            } else {
              await insertAsync({
                ...item,
                followUpType: item.followUpType ?? FollowUpType.Monthly,
                parentRef: res.data?.id,
              });
            }
          });
        }
        refetch && refetch();
        //followupRefetch();
        !isEdit && handleClose();

        isEdit && formik.values.parentRef && handleClose();

        setFollowupId(undefined);
      } else {
        notifications.show("خطا در ذخیره سازی!", {
          key: "err-task",
          severity: "error",
          autoHideDuration: 5000,
        });
      }
      handleClose();
      formik.resetForm();
    },
  });

  const [getEditors, setEditors] = useState<IAutoCompleteLabelValue[]>([]);

  const { mutateAsync: fetchEditors } = useMutation({
    mutationFn: async () => {
      const response = await fetch(
        Routes.UserByRoleRoutes + TypeUser.EDITOR + "/simple",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user?.token}`,
            Accept: "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      
      // بررسی فرمت پاسخ - ممکن است در data property باشد یا مستقیماً آرایه باشد
      if (result && Array.isArray(result)) {
        return result;
      } else if (result && result.data && Array.isArray(result.data)) {
        return result.data;
      } else if (result && result.items && Array.isArray(result.items)) {
        return result.items;
      }
      
      return [];
    },
    onSuccess: (data: IAppUser[]) => {
      if (data)
        setEditors(
          data.map((item: IAppUser) => ({
            label: (item.fName || "") + " " + (item.lName || "") + (item.coName ? ` (${item.coName})` : ""),
            value: item.id,
            item: item,
          }))
        );
    },
    onError: (error) => {
      handleSendMessage(
        notifications,
        "خطا در دریافت اطلاعات" + error,
        "error"
      );
      console.log(error);
    },
  });

  // فراخوانی mutate برای اجرای درخواست
  useEffect(() => {
    open && fetchEditors();
  }, [open]);

  useEffect(() => {
    if (data && isEdit) {
      formik.setValues(data as any);
      formik.setFieldValue(
        "startedOn",
        data?.startedOn && new Date(data?.startedOn)
      );
      formik.setFieldValue("endedOn", data?.endedOn && new Date(data?.endedOn));
      formik.setFieldValue(
        "isGeneral",
        data.customerRef === null ? "false" : "true"
      );

      fetchChildData(data?.id?.toString() ?? "0");
    } else {
      getEditors.length > 0 &&
        formik.setFieldValue(
          "creatorRef",
          getEditors.find(
            (editor: IAutoCompleteLabelValue) =>
              editor.item.userName === user?.userName
          )?.value
        );
    }
  }, [data]);

  useEffect(() => {
    const startedOn = ConvertToMiladiDateDB(formik.values.startedOn);
    const endedOn = ConvertToMiladiDateDB(formik.values.endedOn);
    const period = formik.values.period
      ? formik.values.period === 0
        ? 1
        : formik.values.period
      : 1;
    const followUpType = formik.values.followUpType
      ? (parseInt(formik.values.followUpType, 10) as FollowUpType)
      : FollowUpType.Monthly;
    setDates(calculateDates(startedOn, endedOn, followUpType, period));
  }, [formik.values]);
  React.useEffect(() => {
    if (dates.length > 0) {
      if (!isEdit) {
        setFollwupsSchedule(
          dates.map((item, index) => ({
            id: index,
            customerRef: formik.values.customerRef,
            creatorRef: formik.values.creatorRef,
            title: formik.values.title,
            startedOn: new Date(formik.values.startedOn), // تبدیل به Date
            endedOn: new Date(formik.values.endedOn), // تبدیل به Date
            dueOn: new Date(item),
            followUpType: formik.values.followUpType,
            scheduleStatus: formik.values.scheduleStatus,
            period: formik.values.period,
            isActive: formik.values.isActive,
            isSMS: formik.values.isSMS,
            parentRef: formik.values.parentRef,
            agreementRef: formik.values.agreementRef,
            desc: formik.values.desc,
            isNew: true,
          }))
        );
      } else if (
        formik.values.parentRef === null &&
        followupsSchedule.length > 0
      ) {
        setFollwupsSchedule(
          //@ts-ignore
          followupsSchedule.map((item, index) => ({
            ...item,
            title:
              item.scheduleStatus === StatusGlobal.NotStarted
                ? formik.values.title
                : item.title,
            desc: formik.values.desc,
            childDesc: item.childDesc,
            followUpGroup: item.followUpGroup,
            dueOn:
              item.agreementRef === undefined
                ? item.scheduleStatus === StatusGlobal.NotStarted
                  ? ConvertToMiladiDateDB(dates[index])
                  : item.dueOn
                : item.dueOn,
            isNew: true,
          }))
        );
      }
    }
  }, [dates, formik.values]);

  const handleFetchData = () => {
    fetchData(followupId?.toString() ?? "0");
    fetchChildData(followupId?.toString() ?? "0");
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={() => {
          handleClose();
          formik.resetForm();
          setFollowupId(undefined);
          setFollwupsSchedule([]);
        }}
        fullScreen={
          !(isEdit && data?.parentRef !== null && data?.parentRef !== undefined)
        }
        PaperProps={{
          component: "form",
          onSubmit: formik.handleSubmit,
          sx: {
            minWidth: 500,
          },
        }}
      >
        <DialogTitle>
          پیگیری {isEdit ? ' "' + data?.title + '"' : "جدید"}
        </DialogTitle>
        <DialogContent>
          <TabSchedules
            editors={getEditors}
            isEdit={isEdit}
            refetch={handleFetchData}
            formik={formik}
            followupsSchedule={followupsSchedule}
            setFollwupsSchedule={setFollwupsSchedule}
          />
        </DialogContent>
        <DialogActions>
          <LoadingButton
            loading={isPending || isEditLoading}
            variant="contained"
            color="success"
            size="medium"
            fullWidth
            type="submit"
          >
            ذخیره
          </LoadingButton>
          <Button
            color="error"
            variant="contained"
            onClick={() => {
              handleClose();
              formik.resetForm();
              setFollowupId(undefined);
              setFollwupsSchedule([]);
            }}
          >
            انصراف
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default NewFollowupSchedule;
